import React from 'react';

import { Alert } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { Duration } from 'luxon';

import { BellWhiteIcon } from 'assets/icons';

interface IActionsTaskProps {
  tasks: ICarePlanActionOnTask[];
  dataTestId?: string;
}

export const formatGracePeriodActionTime = (ms: number, intl: any): string => {
  if (!ms) return '';
  const MILISECONDS_DAILY = 86400000;
  const MILISECONDS_WEEKLY = 604800000;
  const MILISECONDS_MONTHLY = 2592000000;
  const duration = Duration.fromMillis(ms);

  if (ms < MILISECONDS_DAILY) {
    return `${duration.as('hours')} ${intl.formatMessage({ id: 'hours' })}`;
  } else if (ms < MILISECONDS_WEEKLY) {
    if (ms % MILISECONDS_DAILY > 0)
      return `${duration.as('hours')} ${intl.formatMessage({ id: 'hours' })}`;
    else return `${duration.as('days')} ${intl.formatMessage({ id: 'daysKey' })}`;
  } else if (ms < MILISECONDS_MONTHLY) {
    if (ms % MILISECONDS_WEEKLY > 0)
      return `${duration.as('days')} ${intl.formatMessage({ id: 'daysKey' })}`;
    else return `${duration.as('weeks')} ${intl.formatMessage({ id: 'weeksKey' })}`;
  } else {
    if (ms % MILISECONDS_MONTHLY > 0) {
      if (ms % MILISECONDS_WEEKLY > 0)
        return `~ ${duration.as('weeks')} ${intl.formatMessage({
          id: 'weeksKey'
        })} (${duration.as('days')} ${intl.formatMessage({ id: 'daysKey' })})`;
      else return `${duration.as('weeks')} ${intl.formatMessage({ id: 'weeksKey' })}`;
    } else return `${duration.as('months')} ${intl.formatMessage({ id: 'monthsKey' })}`;
  }
};

const ActionsTask = ({ tasks, dataTestId }: IActionsTaskProps) => {
  const intl = useIntl();

  return (
    <Alert data-test={`${dataTestId}-actions`} variant="primary" className="mt-3">
      {tasks.map((action, index: number) => (
        <div
          data-test={`${dataTestId}-action-${index}`}
          className="text-sm font-weight-bolder"
          key={index}
        >
          <BellWhiteIcon className="icon me-2" style={{ fontSize: '14px' }} />
          {action.grace_period_action_id && (
            <>
              {intl.formatMessage({
                id: action.grace_period_action_id
              })}{' '}
              - {formatGracePeriodActionTime(action.gracePeriod_ms, intl)}
            </>
          )}
          {action.onCompletionAction?.ruleTag &&
            intl.formatMessage({
              id: action.onCompletionAction.ruleTag
            })}
        </div>
      ))}
    </Alert>
  );
};

export default ActionsTask;
